import axios from 'axios';
import Const from '../../constant/Const';
import { getToken } from '../../store/FlightStore';

let getApi = () => {
    let ax = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            [Const.AUTHORIZATION]: getToken(),
            [Const.LANGUAGE_CODE]: getLanguage()
        },
        timeout: 45000
    });
    ax.interceptors.response.use((response) => {
        if (response.status === 200) {
            return isError(response);
        }
        return { error: true, status: response.status };
    }, error => {
        return { error: true, status: error.status };
    });
    return ax;
};

const getLanguage = () => {
    let lang = localStorage.getItem('i18nextLng')?.toLowerCase();
    if (lang === undefined || lang == null) return 'en';
    if (lang.indexOf('-') > 0)
        lang = lang.substring(0, lang.indexOf('-'));
    if (lang === 'tr' || lang === 'en' || lang === 'es' || lang === 'fr' || lang === 'ru')
        return lang;
    return 'en';
};

const isError = (response) => {
    response.error = false;
    if (response?.data?.responseHeader?.statusCode === 'FAILURE') {
        response.error = true;
    }
    if (response?.data?.messageList !== undefined) {
        if (response.data?.messageList?.length > 0) {
            response.data?.messageList?.forEach(err => {
                if (err.errorType !== null) {
                    response.error = true;
                }
            });
        }
    }
    return response;
};

export const publicKey = () => {
    return getApi().get('/api/publicKey');
};

export const systemLogin = (username, password) => {
    return getApi().post('/api/login', { username: username, code: password });
};

///

export const nowLogin = () => {
    return getApi().get('/api/simulation/now-login');
};

export const isAdminAccess = () => {
    return getApi().get('/api/simulation/isAdmin')
        .then((res) => {
            if (!res?.error) return res;
        })
        .catch(() => {
            return false;
        });
};

export const acceptRights = () => {
    return getApi().get('/api/simulation/accept-rights');
};

export const startSimulation = () => {
    return getApi().get('/api/simulation/start-simulation');
};

export const endSimulation = () => {
    return getApi().get('/api/simulation/end-simulation');
};

export const openPage = (pageName) => {
    return getApi().post('/api/simulation/open-page', { page: pageName });
};

export const getSimulationUserDetails = (page = 0, size = 10, search = '') => {
    const params = { page, size };
    if (search !== undefined && search !== null && search.toString().trim().length > 0) {
        params.search = search.toString().trim();
    }
    return getApi().get('/api/simulation/user-detail', { params });
};

export const getOpenPageDetailsByUsername = (username, page = 0, size = 10) => {
    const params = { username, page, size };
    return getApi().get('/api/simulation/open-page/by-username', { params })
        .then((res) => {
            if (!res?.error) return res;
            return getApi().post('/api/simulation/open-page/by-username', { username, page, size });
        })
        .catch(() => {
            return getApi().post('/api/simulation/open-page/by-username', { username, page, size });
        });
};

export const getSimulationStatusByUsername = (username, page = 0, size = 10) => {
    const params = { username, page, size };
    return getApi().get('/api/simulation/simu-status/by-username', { params })
        .then((res) => {
            if (!res?.error) return res;
            return getApi().get('/api/simu-status/by-username', { params });
        })
        .catch(() => {
            return getApi().get('/api/simu-status/by-username', { params });
        });
};

export const exportSimulationUsersExcel = () => {
    return axios.get(
        `${process.env.REACT_APP_API_URL}/api/simulation/user-detail/export-excel`,
        {
            headers: {
                [Const.AUTHORIZATION]: getToken(),
                [Const.LANGUAGE_CODE]: getLanguage()
            },
            responseType: 'blob',
            timeout: 180000
        }
    );
};
